import formatTimeLabel from './formatTimeLabel';
import timeOptions from './timeOptions';

const getTimeOption = (seconds: number) => {
    const found = timeOptions.find((option) => option.value === seconds);
    if (found) {
        return found;
    }
    if (!Number.isFinite(seconds) || seconds < 0) {
        return undefined;
    }
    return {
        name: `custom-${seconds}`,
        label: formatTimeLabel(seconds),
        value: seconds,
    };
};

export default getTimeOption;
